export default "__VITE_ASSET__3f08f0c5__"